import { Injectable } from '@angular/core';
import { RidangoReduxAction, CardGroup } from '@ridango/core';


@Injectable()
export class CardGroupActions {
    static SET_ALL_CARD_GROUPS = '[Card Groups]: Set All Card Groups';
    static SET_SELECTED_CARD_GROUP = '[Card Groups]: Set Selected Card Group';
    static CLEAR_CARD_GROUPS = '[Card Groups]: Clear Card Groups';
    setAllCardGroups ( payload: CardGroup[] ): RidangoReduxAction {
        return {
            type: CardGroupActions.SET_ALL_CARD_GROUPS,
            payload: payload
        };
    }
    setSelectedCardGroup ( payload: CardGroup ): RidangoReduxAction {
        return {
            type: CardGroupActions.SET_SELECTED_CARD_GROUP,
            payload: payload
        };
    }
    clearCardGroups( ): RidangoReduxAction {
        return {
            type: CardGroupActions.CLEAR_CARD_GROUPS
        };
    }
}
